var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllenAiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24V12V0H24V24H0Z",
    fill: "#0A3235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3039 7.09327C10.4213 6.93327 10.4533 6.5386 10.4533 5.5786V4.2666H13.4399V5.95193C13.4399 7.19993 13.3973 7.77593 13.2693 8.21327C13.1413 8.6186 12.9386 8.94927 12.5973 9.31193C12.3306 9.58927 11.8933 9.9306 11.6266 10.0479C11.1999 10.2506 10.9226 10.2826 7.35993 10.3466V7.35993L8.75727 7.3386C10.0159 7.3066 10.1653 7.28527 10.3039 7.09327Z",
    fill: "#F45096"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9413 11.6373C13.7493 11.2106 13.7173 10.9119 13.6746 9.2586L13.6319 7.3706H16.6399V8.70393C16.6399 9.88793 16.6613 10.0586 16.8533 10.2506C17.0453 10.4319 17.2053 10.4639 19.7333 10.4639V13.4506H18.0479C16.7999 13.4506 16.2239 13.4079 15.7866 13.2693C15.3706 13.1519 15.0399 12.9493 14.6879 12.6079C14.3999 12.3306 14.0693 11.8933 13.9413 11.6373Z",
    fill: "#F45096"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2666 13.5466V12.0533V10.5599H5.94127C7.19993 10.5599 7.76527 10.6026 8.21327 10.7306C8.6186 10.8586 8.94927 11.0613 9.31193 11.4026C9.58927 11.6693 9.91993 12.1066 10.0479 12.3733C10.2506 12.7999 10.2826 13.0773 10.3466 16.6399H7.35993L7.32793 15.2426C7.3066 13.9839 7.28527 13.8346 7.09327 13.6959C6.93327 13.5786 6.5386 13.5466 4.2666 13.5466Z",
    fill: "#F45096"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1066 14.0693C12.2773 13.9626 12.6399 13.8239 12.9066 13.7706C13.1626 13.7173 14.1119 13.6746 16.6399 13.6533V16.6399H15.3066C14.1119 16.6399 13.9413 16.6613 13.7599 16.8533C13.5679 17.0453 13.5466 17.2053 13.5466 19.7333H10.5599L10.5493 18.0586C10.5493 16.8746 10.6026 16.2026 10.7093 15.8186C10.8159 15.4453 11.0293 15.0826 11.3279 14.7626C11.5733 14.4959 11.9253 14.1866 12.1066 14.0693Z",
    fill: "#F45096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllenAiLogo);
export default __webpack_public_path__ + "static/media/allen_ai_logo.2bea187e447a63b036f7b7dcf7a8ecdd.svg";
export { ForwardRef as ReactComponent };